<template>
  <div>
    <vx-breadcrumb
      :list="breadcrumbList"
      @breadcrumb-click="handleBreadcrumbNavigation"
      class="custom-bread-crumb"
    />
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul flex justify-between items-center">
          <li>
            <div @click="backRoute" class="vx-row cursor-pointer">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4 class="table-heading">{{ $t("customers.label.bill_item_details") }}</h4>
          </div>
          </li>
          <li class="ml-auto">
            <h3>
              {{ $t("customers.label.total_net_amount") }} :
              {{ $route.params.amount.toFixed(2) || 0 }}
            </h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="w-full">
              <div class="details-layout-2 p-2">
                <vs-table :data="billItemDetails">
                  <template slot="thead">
                    <vs-th>
                      <b>{{ $t("customers.label.charge_id") }}</b>
                    </vs-th>
                    <vs-th>
                      <b>{{ $t("customers.label.order_id") }}</b>
                    </vs-th>
                    <vs-th>
                      <b>{{ $t("customers.label.charge_type") }}</b>
                    </vs-th>
                    <vs-th>
                      <b>{{ $t("customers.label.charge_description") }}</b>
                    </vs-th>
                    <vs-th>
                      <b>{{ $t("customers.label.start_date") }}</b>
                    </vs-th>
                    <vs-th>
                      <b>{{ $t("customers.label.end_date") }}</b>
                    </vs-th>
                    <vs-th>
                      <b>{{ $t("customers.label.amount") }}</b>
                    </vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr v-for="(billItem, index) in data" :key="index">
                      <vs-td>{{ billItem.chargeId }}</vs-td>
                      <vs-td>{{ billItem.orderId }}</vs-td>
                      <vs-td>{{ billItem.chargeType }}</vs-td>
                      <vs-td>{{ billItem.chargeDescription }}</vs-td>
                      <vs-td>{{ getDate(billItem.chargeStartDate) }}</vs-td>
                      <vs-td>{{ getDate(billItem.chargeEndDate) }}</vs-td>
                      <vs-td>{{ billItem.chargeAmount.toFixed(2) }}</vs-td>
                    </vs-tr></template
                  >
                </vs-table>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="w-full">
              <div class="table-heading">
                {{ $t("customers.label.discount_details") }}
              </div>
              <div class="details-layout-2 p-2">
                <vs-table :data="discountDetails">
                  <template slot="thead">
                    <vs-th>
                      <b>{{ $t("customers.label.ChargeId") }}</b>
                    </vs-th>
                    <vs-th>
                      <b>{{ $t("customers.label.ChargeDescription") }}</b>
                    </vs-th>
                    <vs-th>
                      <b>{{ $t("customers.label.DiscountAmount") }}</b>
                    </vs-th>
                    <vs-th>
                      <b>{{ $t("customers.label.NetChargeAmount") }}</b>
                    </vs-th></template
                  >
                  <template slot-scope="{ data }">
                    <vs-tr v-for="(Broadcaster, index) in data" :key="index">
                      <td>{{ Broadcaster.chargeId }}</td>
                      <td>{{ Broadcaster.chargeDescription }}</td>
                      <td>{{ Broadcaster.discountAmount.toFixed(2) }}</td>
                      <td>{{ Broadcaster.netChargeAmount.toFixed(2) }}</td>
                    </vs-tr></template
                  >
                </vs-table>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="w-full">
              <div class="table-heading">
                {{ $t("customers.label.item_tax_details") }}
              </div>
              <div class="details-layout-2 p-2">
                <vs-table :data="taxItemDetails">
                  <template slot="thead">
                    <vs-th>
                      <b>{{ $t("customers.label.ChargeId") }}</b>
                    </vs-th>
                    <vs-th>
                      <b>{{ $t("customers.label.TaxDescription") }}</b>
                    </vs-th>
                    <vs-th>
                      <b>{{ $t("customers.label.TaxAmount") }}</b>
                    </vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr v-for="(Broadcaster, index) in data" :key="index">
                      <td>{{ Broadcaster.chargeId }}</td>
                      <td>{{ Broadcaster.chargeDescription }}</td>
                      <td>{{ Broadcaster.taxAmount.toFixed(2) }}</td>
                    </vs-tr></template
                  >
                </vs-table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteBroadcasterPopup"
      title=" Broadcaster"
      @deletePressed="deleteBroadcaster()"
      @cancelPressed="deleteBroadcasterPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import moment from "moment";
import { mapState } from "vuex";
import VxBreadcrumb from "@/layouts/components/VxBreadcrumb.vue";
export default {
  data() {
    return {
      breadcrumbList: [
        { name: "Customers", path: "/customers" },
        {
          name: "View Customer",
          path: `/customers/view_customer/${this.$route.params.clientId}`,
        },
        {
          name: "View Financial Transaction",
        },
      ],
      id: "",
      clientId: "",
      billItemDetails: [],
      taxItemDetails: [],
      discountDetails: [],
      viewBroadcaster: {},
      editJobsPopup: false,
      delId: 0,
      redirectToEdit: false,
      deleteBroadcasterPopup: false,
      updateCraditPopup: false,
      jobsParameterPopup: false,
    };
  },
  components: {
    "v-select": vSelect,
    VxBreadcrumb,
  },
  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    backRoute(){
      this.$router.push({
        path: `/customers/view_customer/${this.$route.params.clientId}`,
        query: { activePage: 7 },
      });
    },
    async getTransactionDetails() {
      try {
        const financialTransaction = await this.$store.dispatch(
          "customerAccount/getFinancialTransactionAction",
          this.id
        );
        this.billItemDetails = [];
        this.taxItemDetails = [];
        this.discountDetails = [];
        financialTransaction &&
          financialTransaction.data &&
          financialTransaction.data.transactionsDatas.forEach((transaction) => {
            if (transaction.chargeType === "Discount") {
              this.discountDetails.push(transaction);
            } else if (transaction.chargeType === "Tax") {
              this.taxItemDetails.push(transaction);
            } else {
              this.billItemDetails.push(transaction);
            }
          });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  async mounted() {
    this.id = this.$route.params.id;
    await this.getTransactionDetails();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
